<div class="company-permissions">
  <div class="multi-factor-authentication fields">
    <h4>{{ 'permissions.MultiFactorAuthentication' | translate | titlecase }}</h4>

    <mat-slide-toggle #mfa class="mfa-toggle" color="primary" [checked]="UseMultiFactorAuthentication" (change)="onToggleMfa($event)">
      {{ mfa.checked ? ('permissions.toggleNameEnabled' | translate) : ('permissions.toggleNameDisabled' | translate) }}
    </mat-slide-toggle>
  </div>

  <div class="local-authentication fields">
    <h4>{{ 'permissions.LocalDeviceAuthentication' | translate }}</h4>

    <mat-slide-toggle class="permission-toggle" color="primary" [checked]="isLocalAuthentication" (change)="toggleIsLocalAuthentication($event)">
      {{ isLocalAuthentication ? ('permissions.toggleNameEnabled' | translate) : ('permissions.toggleNameDisabled' | translate) }}
    </mat-slide-toggle>
  </div>

  <div class="shared-asset fields">
    <h4>{{ 'permissions.sharedAssetAccess' | translate | titlecase }}</h4>

    <mat-slide-toggle class="permission-toggle" color="primary" [checked]="isPublicAccessToggleChecked" (change)="togglePublicAccessPermission($event)">
      {{ isPublicAccessToggleChecked ? ('permissions.toggleNameEnabled' | translate) : ('permissions.toggleNameDisabled' | translate) }}
    </mat-slide-toggle>
  </div>

  <div class="permission-crud fields">
    <h4 class="company-permission-title">
      {{ 'permissions.teamPermissions' | translate | titlecase }}
    </h4>

    <mee-permissions-crud
      [permissions]="permissions"
      (onChangePermissions)="onCrudPermissionsChanged($event)"></mee-permissions-crud>
  </div>
</div>
